import Vue from 'vue'
import Router from 'vue-router'
import Register from '@/components/Register'
import store from '@/store/store'

Vue.use(Router)

const router = new Router({
  mode: 'history',
  routes: [
    {
      path: '/register',
      name: 'register',
      component: Register,
      meta: {
        Auth: true
      }
    },
    {
      path: '/login',
      name: 'login',
      component: () => import('@/components/Login')
    },
    {
      path: '/sponsor_portal',
      name: 'sponsorlogin',
      component: () => import('@/components/SponsorLogin')
    },
    {
      path: '/vendor_portal',
      name: 'vendorlogin',
      component: () => import('@/components/VendorLogin')
    },
    {
      path: '/forgot_password',
      name: 'forgotpassword',
      component: () => import('@/components/ForgotPassword')
    },
    {
      path: '/reset_password',
      name: 'resetpassword',
      component: () => import('@/components/ResetPassword')
    },
    {
      path: '/ex_muttonBustin',
      name: 'mb_form',
      component: () => import('@/components/muttonBustin/ExternalForm')
    },
    {
      path: '/vendor_registration',
      name: 'vr_form',
      component: () => import('@/components/vendor/ExternalForm')
    },
    {
      path: '/ticket',
      name: 'ticket',
      component: () => import('@/components/Ticket'),
      meta: {
        Auth: true
      }
    },
    {
      path: '/users',
      name: 'users',
      component: () => import('@/components/Users'),
      meta: {
        Auth: true
      }
    },
    {
      path: '/liability',
      name: 'liability',
      component: () => import('@/components/Liability')
    },
    {
      path: '/committee-list',
      name: 'committee-list',
      component: () => import('@/components/committees/List'),
      meta: {
        Auth: true
      }
    },
    {
      path: '/committees/:committee/:currentYear',
      name: 'committees',
      component: () => import('@/components/committees/Committees'),
      meta: {
        Auth: true
      }
    },
    {
      path: '/committee-schedule/:committee/:currentYear/:committeeId',
      name: 'committee-schedule',
      component: () => import('@/components/schedule/List'),
      meta: {
        Auth: true
      }
    },
    {
      path: '/schedule/:committeeId',
      name: 'schedule',
      component: () => import('@/components/myschedule/List'),
      meta: {
        Auth: true
      }
    },
    {
      path: '/contacts',
      name: 'contacts',
      component: () => import('@/components/Contacts'),
      meta: {
        Auth: true
      }
    },
    {
      path: '/calendar',
      name: 'calendar',
      component: () => import('@/components/Calendar'),
      meta: {
        Auth: true
      }
    },
    {
      path: '/document',
      name: 'document',
      component: () => import('@/components/Document'),
      meta: {
        Auth: true
      }
    },
    {
      path: '/muttonbustin-list',
      name: 'muttonbustin-list',
      component: () => import('@/components/muttonBustin/List'),
      meta: {
        Auth: true
      }
    },
    {
      path: '/mbchamp-list',
      name: 'mbchamp-list',
      component: () => import('@/components/mbChampionship/List'),
      meta: {
        Auth: true
      }
    },
    {
      path: '/settings/mobile-types',
      name: 'mobile-types',
      component: () => import('@/components/settings/MobileTypes'),
      meta: {
        Auth: true
      }
    },
    {
      path: '/settings/certificates',
      name: 'cert-types',
      component: () => import('@/components/settings/Certificates'),
      meta: {
        Auth: true
      }
    },
    {
      path: '/settings/badges',
      name: 'badges',
      component: () => import('@/components/settings/Badges'),
      meta: {
        Auth: true
      }
    },
    {
      path: '/settings/committees',
      name: 'committee-settings',
      component: () => import('@/components/settings/Committees'),
      meta: {
        Auth: true
      }
    },
    {
      path: '/vendor-list',
      name: 'vendor-list',
      component: () => import('@/components/vendor/Enter'),
      meta: {
        Auth: true
      }
    },
    {
      path: '/sponsor-list',
      name: 'sponsor-list',
      component: () => import('@/components/sponsor/Enter'),
      meta: {
        Auth: true
      }
    },
    {
      path: '/settings/liasons',
      name: 'liasons',
      component: () => import('@/components/settings/Liasons'),
      meta: {
        Auth: true
      }
    },
    {
      path: '/settings',
      name: 'settings',
      component: () => import('@/components/settings/List'),
      meta: {
        Auth: true
      }
    },
    {
      path: '/texting',
      name: 'texting',
      component: () => import('@/components/texting/List'),
      meta: {
        Auth: true
      }
    },
    {
      path: '/table2',
      name: 'table2',
      component: () => import('@/components/Table2'),
      meta: {
        Auth: true
      }
    },
    {
      path: '/table3',
      name: 'table3',
      component: () => import('@/components/Table3'),
      meta: {
        Auth: true
      }
    },
    {
      path: '/table4',
      name: 'table4',
      component: () => import('@/components/Table4'),
      meta: {
        Auth: true
      }
    },
    {
      path: '/vuedrag',
      name: 'vuedrag',
      component: () => import('@/components/VueDrag'),
      meta: {
        Auth: true
      }
    },
    {
      path: '/members',
      name: 'members',
      component: () => import('@/components/Members'),
      meta: {
        Auth: true
      }
    },
    {
      path: '/purchase_orders',
      name: 'purchase_orders',
      component: () => import('@/components/PurchaseOrders'),
      meta: {
        Auth: true
      }
    },
    {
      path: '/emp',
      name: 'emp',
      component: () => import('@/components/Products'),
      meta: {
        Auth: true
      }
    },
    {
      path: '*',
      name: 'dashboard',
      component: () => import('@/components/dashboard/Dashboard'),
      meta: {
        Auth: true
      }
    }
  ]
})

router.beforeEach((to, from, next) => {
  if (to.matched.some(record => record.meta.Auth)) {
    if (!store.state.isUserLoggedIn) {
      next({
        path: '/login',
        query: { redirect: to.fullPath }
      })
    } else {
      next()
    }
  } else {
    next()
  }
})

export default router



// WEBPACK FOOTER //
// ./src/router/index.js